import { render, staticRenderFns } from "./FormThuxHorizontalColorPicker.vue?vue&type=template&id=826588a2&"
import script from "./FormThuxHorizontalColorPicker.vue?vue&type=script&lang=js&"
export * from "./FormThuxHorizontalColorPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports